import script from "./CustomersPhotosSkeleton.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomersPhotosSkeleton.vue?vue&type=script&setup=true&lang=ts"

import "./CustomersPhotosSkeleton.vue?vue&type=style&index=0&id=76b6556a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76b6556a"]])

export default __exports__